<template>
  <div class="d-flex align-center">
    <v-text-field
      :id="id"
      v-model="localValue"
      :label="label"
      :type="type"
      :required="required"
      :rules="processedRules"
      :loading="isUpdating"
      :error="hasError || validationError"
      :success="showSuccess && !validationError"
      outlined
      dense
      v-bind="$attrs"
      class="flex-grow-1"
      @input="onInput"
      @update:error="onErrorUpdate"
    >
      <template #append>
        <v-icon
          v-if="showSuccess && !validationError"
          color="success"
        >
          mdi-check-circle
        </v-icon>
      </template>
    </v-text-field>
    <slot
      name="append-button"
      :set-value="setValue"
    />
  </div>
</template>

<script>
import ProductInfoFieldMixin from '@/mixins/ProductInfoFieldMixin';

export default {
  name: 'LocalBookTextInput',
  mixins: [ProductInfoFieldMixin],
  inheritAttrs: false,
  props: {
    id: { type: String, required: true },
    label: { type: String, default: '' },
    required: { type: Boolean, default: false },
    rules: { 
      type: [String, Array],
      default: () => []
    },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: 'text' }
  },
  emits: ['valid'],
  computed: {
    processedRules() {
      if (typeof this.rules === 'string') {
        return this.rules ? this.rules.split('|') : [];
      }
      return this.rules;
    },
    isFieldValid() {
      return !this.isUpdating && !this.validationError && !this.hasError;
    }
  },
  watch: {
    isFieldValid(newVal) {
      this.$emit('valid', newVal);
    }
  },
  mounted() {
    this.$emit('valid', this.isFieldValid);
  },
  methods: {
    setValue(value) {
      this.localValue = value;
      this.onInput(value);
    },
    onErrorUpdate(val) {
      this.validationError = val;
    }
  }
};
</script>
